"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internal
 */
class RecursiveError extends ReferenceError {
    static assert(iif) {
        const proxyHandler = {
            apply() {
                throw new RecursiveError();
            },
        };
        const result = iif((fn) => new Proxy(fn, proxyHandler));
        delete proxyHandler.apply;
        return result;
    }
    constructor() {
        super("Cannot call the 'self' guard inside the constructor function when using the recursive mode");
    }
}
exports.default = RecursiveError;
